import { faqItems } from '@/mocks/anime';

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            关于51动漫网下载与使用的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line text-primary-500 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                      {item.question}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}